module.exports = __webpack_public_path__ + "static/media/logo-evah.f35d9f5a.svg";